import React, { useEffect, useState } from 'react'
import { getDeletedForms } from "../../../services/PharmacyUser";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContentText from "@mui/material/DialogContentText";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useModal } from "react-hooks-use-modal";
import ReviewResponse from "../formCenter/ReviewResponse";
import CloseIcon from "@mui/icons-material/Close";
const DeletedForms = () => {

  const [deletedForms, setDeletedForms] =useState([]);
    const [Modal, open, close] = useModal("root", {
      preventScroll: false,
      focusTrapOptions: {
        clickOutsideDeactivates: true,
      },
    }); 
    const  [currentForm,setCurrentForm] = useState(null);
        const columns = [
          { field: "id", headerName: "ID", width: 70 },
          { field: "actionDate", headerName: "Action Date", width: 180 },
          { field: "actionType", headerName: "Action Type", width: 130 },
          { field: "actionUser", headerName: "Action User ID", width: 120 },
          // { field: "formId", headerName: "Form ID", width: 100 },
          // { field: "actionDetails", headerName: "Action Details", width: 200,  },
          { headerName: "Action Details", width: 200, renderCell: (params) => <button className="btn btn-primary" onClick={() => {setCurrentForm(params.row);open()}}>View</button> },
          { field: "firstName", headerName: "First Name", width: 130 },
          { field: "lastName", headerName: "Last Name", width: 130 },
          { field: "email", headerName: "Email", width: 200 },
          { field: "phone", headerName: "Phone", width: 150 },
          { field: "type", headerName: "User Type", width: 150 },
          {
            field: "active",
            headerName: "Active Status",
            width: 120,
            type: "boolean",
          },
        ];

  const handleGetDeletedForms = () => {
    getDeletedForms()
      .then((res) => {
        setDeletedForms(res.data);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    handleGetDeletedForms();
  }, []);
const paginationModel = { page: 0, pageSize: 50 };

  return (
    <>
      <div className="container-fluid">
        <DialogTitle id="alert-dialog-title">
          History of Deleted Forms.
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <DataGrid
              rows={deletedForms}
              columns={columns}
              initialState={{ pagination: { paginationModel } }}
              pageSizeOptions={[5, 10, 25, 50, 100]}
              checkboxSelection
              sx={{ border: 0, height: "100%", width: "100%" }}
              slots={{ toolbar: GridToolbar }}
            />
          </DialogContentText>
        </DialogContent>
      </div>
      <Modal>
        {
          <div
            className="card p-3"
            style={{
              width: "80vw",
              height: "80vh",
            }}
          >
            <button
              onClick={() => {
                close();
                setCurrentForm(null);
              }}
              className="btn btn-outline-danger mb-4 p-1"
              style={{ width: "2.1rem" }}
            >
              <CloseIcon />
            </button>
            {currentForm ? (
              <div style={{ maxHeight: "70vh", overflowY: "scroll" }}>
                <ReviewResponse data={currentForm} />
              </div>
            ) : null}
          </div>
        }
      </Modal>
    </>
  );
}

export default DeletedForms